import styled, { css } from 'styled-components';

export const BenefitsList = styled.ul(
  () => css`
    margin: unset;
  `,
);

export const BenefitsListItem = styled.li(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    margin-top: ${theme.sz.s4};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.l};
      margin-top: ${theme.sz.s6};
    }

    &:first-of-type {
      margin-top: unset;
    }
  `,
);

export const Bold = styled.span(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xs};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.xs};
    }
  `,
);

export const Link = styled.a(
  () => css`
    color: inherit;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  `,
);

export const MovieCard = styled.article(
  ({ theme }) => css`
    width: 100%;
    max-width: ${theme.sz.md};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: ${theme.sz.s4};
    color: ${theme.co.secondary10};

    @media (min-width: ${theme.sz.md}) {
      gap: ${theme.sz.s6};
    }
  `,
);

export const Paragraph = styled.p(
  ({ theme }) => css`
    margin: unset;
    ${theme.typography.paragraph.base};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.l};
    }
  `,
);

export const Poster = styled.img(
  ({ theme }) => css`
    width: 100%;
    aspect-ratio: 640/356;
    border-radius: ${theme.bo.mediumSmall};
    object-fit: cover;

    @media (min-width: ${theme.sz.md}) {
      border-radius: ${theme.bo.mediumLarge};
    }
  `,
);

export const StreamingLinks = styled.span(
  ({ theme }) => css`
    color: ${theme.co.information30};
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    margin: unset;
    ${theme.typography.heading.mobile.m};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.m};
    }
  `,
);
